// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__G6_XU","image":"Header_image__27-Wq","name":"Header_name__24MNv","info":"Header_info__2ISGS","infoRow":"Header_infoRow__2Ksuq"};